import { useState } from "react";
import { notify } from "../utils/utils";
import { Fetch } from "../services/api";


const urlGeneral= process.env.REACT_APP_XPROJECT_API + "/General";
const urlGeneralTemp  = 'https://xprojectwebapi.abexacloud.com/api/General'
export const useGeneral = () => {
    
    const [ tiposTickets, setTipoTickets ] = useState([]);
    const [ prioridades, setPrioridades ] = useState([])  

    const [ubicacionesMenu, setUbicacionesMenus] = useState([])

    const listarTiposTickets = async () => {

        const response = await Fetch({
            url: urlGeneral + '/typeTickets'
        });

        if (response.isValid){
            setTipoTickets(response.content);
        }else{
            notify(response.content)
        }
    }

    const listarUbicacionMenu = async (codEmpresa) => {
        if(codEmpresa){
            const response = await Fetch({
                url: 
                    codEmpresa !== 4 ? 
                        urlGeneralTemp + '/menuLocation?' + new URLSearchParams({
                            CodEmpresa: codEmpresa //|| 25
                        })
                    :
                    urlGeneralTemp + '/menuLocationXbest'
            });
            
            !response.isValid && notify(response.exceptions[0].description)
            if (response.isValid){
                setUbicacionesMenus(response.content);
            }
        }
    }
    
    const listarPrioridades = async () => {
        const response = await Fetch({
            url: urlGeneral + '/priorities'
        });

        if (response.isValid){
            setPrioridades(response.content);
        }else{
            notify(response.content)
        }
    }


    return {
        tiposTickets,
        prioridades,
        listarPrioridades,
        listarTiposTickets,
        listarUbicacionMenu,
        ubicacionesMenu
    };
}